import CircularProgress from "@mui/material/CircularProgress";

// Inline styles because this component can render before the stylesheet loads.
const overlayStyle = {
  position: "fixed",
  inset: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2499,
};

const Loading = ({ partial = false }) => {
  return (
    <div
      style={{
        ...overlayStyle,
        backgroundColor: partial
          ? "rgba(255, 255, 255, 0.5)"
          : "rgb(255, 255, 255)",
      }}
    >
      <CircularProgress color="secondary" disableShrink size={100} />
    </div>
  );
};

export default Loading;
